<app-website-header></app-website-header>
<div class="doctor-info">
  <div class="doctor-profile">
    <div class="doctor-intro">
      <ng-container *ngIf="doctor?.image; else noImage">
        <img
          [src]="doctor.image"
          class="doctor-profile-image"
          alt="Doctor Profile Image"
        />
      </ng-container>
      <ng-template #noImage>
        <div class="doctor-initial">{{ getInitial(doctor?.name) }}</div>
      </ng-template>
      <div class="doctor-name-section">
        <h1 class="doctor-name">{{ doctor?.name }}</h1>
        <span class="doctor-specialization">{{ doctor?.specialty }}</span>
        <p>{{ doctor?.workingIn }}</p>
      </div>
    </div>
    <div class="doctor-contacts">
      <section class="contact-section">
        <div class="contact-email">
          <div class="contact-divs" *ngIf="doctor?.email">
            <img
              src="assets/images/doctors-email.svg"
              alt="Email Icon"
              style="width: 24px; height: 24px"
              class="email-icon"
            />
            <strong class="contact-info">Email Now</strong>
          </div>
          <span
            (click)="openGmail()"
            style="cursor: pointer"
            class="contact-value"
            >{{ doctor?.email }}</span
          >
        </div>
        <div class="contact-portfolio">
          <p *ngIf="!doctor.url" class="to-be-updated">To Be Updated Soon</p>
          <strong *ngIf="doctor.url" class="contact-info">My Portfolio</strong>
          <a
            *ngIf="doctor.url"
            [href]="formattedUrl(doctor?.url)"
            target="_blank"
            class="contact-value"
            >{{ doctor?.url }}</a
          >
        </div>
      </section>
      <section class="contact-section">
        <div class="contact-phone">
          <div class="contact-divs" *ngIf="doctor?.phone">
            <img
              src="assets/images/doctors-phone.svg"
              alt="Phone Icon"
              style="width: 24px; height: 24px"
              class="phone-icon"
            />
            <strong class="contact-info">Call Now</strong>
          </div>
          <span
            (click)="openDialPad()"
            style="cursor: pointer"
            class="contact-value"
            >{{ doctor?.phoneCode }} {{ doctor?.phone }}</span
          >
        </div>
        <div class="social-connect">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
            "
          >
            <p class="contact-info" style="margin-bottom: 8px">
              Connect with me
            </p>
            <div
              style="display: flex; justify-content: space-around; gap: 10px"
            >
              <a (click)="openInNewTab(doctor?.instagramUrl)">
                <img
                  src="assets/images/doctors-insta.svg"
                  alt="Instagram"
                  style="width: 24px; height: 24px"
                />
              </a>
              <a (click)="openInNewTab(doctor?.facebookUrl)">
                <img
                  src="assets/images/doctors-facebook.svg"
                  alt="Facebook"
                  style="width: 24px; height: 24px"
                />
              </a>
              <a (click)="openInNewTab(doctor?.linkedin)">
                <img
                  src="assets/images/Logo linkedin 1.svg"
                  alt="LinkedIn"
                  style="width: 24px; height: 24px"
                />
              </a>
              <a (click)="openInNewTab(doctor?.twitterUrl)">
                <img
                  src="assets/images/doctors-twitter.svg"
                  alt="Twitter"
                  style="width: 24px; height: 24px"
                />
              </a>
            </div>
          </div>
        </div>
      </section>
      <div class="contact-qrCode">
        <img class="qrCode" [src]="doctor?.qrCode" alt="" />
      </div>
    </div>
  </div>
  <div class="doctor-education-work">
    <div class="doctor-education-header">
      <span class="doctor-education-title">Education & Work Experience</span>
      <p>
        A strong foundation of education and years of hands-on experience ensure
        the highest standards of care in every patient interaction.
      </p>
    </div>
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px 0px;
      "
    >
      <div class="middle-section" style="display: flex; width: 100% !important">
        <div style="height: 100%; width: 50% !important"></div>
        <div
          class="education-details"
          style="max-width: 100% !important; width: 100% !important"
          [class.hasNonEmptyEducationAndWorkExperience]="
            hasNonEmptyEducationAndWorkExperience
          "
        >
          <img alt=".." src="..\..\assets\images\education-details.png" />
          <div class="education-info">
            <span>Education Details</span>
            <p *ngIf="!doctor?.educationInfos?.length" class="to-be-updated">
              To Be Updated Soon
            </p>
            <div class="scrollable-list" *ngIf="doctor?.educationInfos?.length">
              <ul *ngFor="let education of doctor?.educationInfos?.slice(0, 2)">
                <li style="color: #949494">
                  <b
                    >{{ formattedTilteCase(education?.degree)
                    }}<span *ngIf="education?.degree">,</span>
                    {{ formattedTilteCase(education?.fieldOfStudy) }}</b
                  ><br />
                  <span
                    style="
                      color: #949494;
                      font-weight: 600;
                      font-size: 16px;
                      position: relative;
                      top: -5px;
                      text-transform: capitalize;
                    "
                  >
                    {{ formattedTilteCase(education?.instituteName)
                    }}<span *ngIf="education?.instituteName"
                      ><span style="color: #949494">,</span></span
                    >
                    {{ education?.location }}</span
                  ><br />
                  <span
                    style="
                      color: #b3b3b3;
                      font-weight: 400;
                      font-size: 16px;
                      position: relative;
                      top: -8px;
                    "
                    >{{
                      education?.yearFrom
                        ? education?.yearTo
                          ? education?.yearFrom + " To " + education?.yearTo
                          : education?.yearFrom
                        : ""
                    }}</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        class="last-section"
        style="
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0 70px;
          width: 90%;
        "
      >
        <div
          class="last-section-sub-left"
          style="
            display: flex;
            flex-direction: column;
            gap: 20px 0px !important;
          "
        >
          <div
            class="education-details"
            [class.hasNonEmptyEducationAndWorkExperience]="
              hasNonEmptyEducationAndWorkExperience
            "
          >
            <img alt=".." src="..\..\assets\images\work-experience.png" />
            <div class="education-info">
              <span>Work Experience</span>
              <p *ngIf="!doctor?.workInfos?.length" class="to-be-updated">
                To Be Updated Soon
              </p>
              <div class="scrollable-list" *ngIf="doctor?.workInfos?.length">
                <ul *ngFor="let work of doctor?.workInfos?.slice(0, 2)">
                  <li style="color: #949494">
                    <b>{{ formattedTilteCase(work?.designation) }}</b
                    ><br />
                    <span
                      style="color: #949494; font-weight: 600; font-size: 16px"
                      >{{ formattedTilteCase(work?.organization) }}</span
                    ><br />
                    <span
                      style="
                        color: #b3b3b3;
                        font-weight: 400;
                        font-size: 16px;
                        position: relative;
                        top: -5px;
                      "
                      >{{
                        work?.yearFrom && work?.yearTo
                          ? work?.monthFrom +
                            " " +
                            work?.yearFrom +
                            " To " +
                            (work?.yearTo === currentYear
                              ? "Present"
                              : work?.monthTo + " " + work?.yearTo)
                          : ""
                      }}</span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="education-details"
            [class.hasNonEmptyEducationAndWorkExperience]="
              hasNonEmptyEducationAndWorkExperience
            "
          >
            <img alt=".." src="..\..\assets\images\skill-set.png" />
            <div class="education-info">
              <span>Skill Set</span>
              <p *ngIf="!doctor?.skills?.length" class="to-be-updated">
                To Be Updated Soon
              </p>
              <div class="scrollable-list" *ngIf="doctor?.skills?.length">
                <ul *ngFor="let skill of doctor?.skills?.slice(0, 5)">
                  <li>{{ formattedTilteCase(skill) }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          class="last-section-sub-right"
          style="
            display: flex;
            flex-direction: column;
            gap: 20px 0px !important;
          "
        >
          <div
            class="education-details"
            [class.hasNonEmptyEducationAndWorkExperience]="
              hasNonEmptyEducationAndWorkExperience
            "
          >
            <img alt=".." src="..\..\assets\images\certifications.png" />
            <div class="education-info">
              <span>Certifications & Licenses</span>
              <p *ngIf="!doctor?.certificates?.length" class="to-be-updated">
                To Be Updated Soon
              </p>
              <div class="scrollable-list" *ngIf="doctor?.certificates?.length">
                <ul *ngFor="let cert of doctor?.certificates?.slice(0, 2)">
                  <li style="color: #949494">
                    <b>{{ formattedTilteCase(cert?.name) }}</b>
                    <br />
                    <span
                      style="color: #949494; font-weight: 600; font-size: 16px"
                      >{{ formattedTilteCase(cert?.organizationName) }}</span
                    ><br />
                    <span
                      style="
                        color: #b3b3b3;
                        font-weight: 400;
                        font-size: 16px;
                        position: relative;
                        top: -5px;
                      "
                      >{{ cert?.year }}</span
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="education-details"
            [class.hasNonEmptyEducationAndWorkExperience]="
              hasNonEmptyEducationAndWorkExperience
            "
          >
            <img alt=".." src="..\..\assets\images\specialities-img.png" />
            <div class="education-info">
              <span>Specialities</span>
              <p *ngIf="!doctor?.services?.length" class="to-be-updated">
                To Be Updated Soon
              </p>
              <div class="scrollable-list">
                <ul *ngFor="let service of doctor?.services?.slice(0, 5)">
                  <li>{{ formattedTilteCase(service.name) }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="doctor-achievements">
    <span style="font-size: calc(1.3rem + 0.3vw)"
      >Achievements & Contributions</span
    >
    <div class="doctor-cards-container">
      <img
        class="d-none d-lg-block custom-hide"
        src="assets/images/specialities_left-arrow.svg"
        alt="Left Arrow"
        (click)="slide('left', 'specialityContainer')"
        [class.disabled]="!canSlideLeftSpecialities"
        style="cursor: pointer"
      />
      <div class="contributions">
        <div class="doctor-publications">
          <span class="cardTitle">Publications</span>
          <p
            *ngIf="!(doctor?.moreInfos?.[0]?.publications?.length)"
            class="to-be-updated"
          >
            To Be Updated Soon
          </p>
          <ul>
            <ng-container *ngFor="let info of doctor?.moreInfos">
              <li *ngFor="let pub of doctor?.publications">
                <b class="doctor-title">{{ pub.title }}</b>
                <div class="publications-detail-row">
                  <span class="doctor-acheivement-label">Published by :</span>
                  <span class="doctor-acheivement-value">{{
                    pub?.publishedby || "N/A"
                  }}</span>
                </div>
                <div class="publications-detail-row">
                  <span class="doctor-acheivement-label">Published Date :</span>
                  <span class="doctor-acheivement-value">{{
                    pub?.publicationDate | date : "MM/dd/yyyy"
                  }}</span>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="doctor-publications">
          <span class="cardTitle">Awards & Honors</span>
          <p
            *ngIf="!(doctor?.moreInfos?.[0]?.awards?.length)"
            class="to-be-updated"
          >
            To Be Updated Soon
          </p>
          <ul>
            <li *ngFor="let award of doctor?.awards">
              <b>{{ award?.title }}</b>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">Awarded by :</span>
                <span class="doctor-acheivement-value">{{
                  award?.association || "N/A"
                }}</span>
              </div>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">Awarded Date :</span>
                <span class="doctor-acheivement-value">{{
                  award?.awardDate | date : "MM/dd/yyyy"
                }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="doctor-publications">
          <span class="cardTitle">Courses & Training</span>
          <p
            *ngIf="!(doctor?.moreInfos?.[0]?.courseTrainings?.length)"
            class="to-be-updated"
          >
            To Be Updated Soon
          </p>
          <ul>
            <li *ngFor="let course of doctor?.courseTrainings">
              <b>{{ course?.title }}</b>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">Institution :</span>
                <span class="doctor-acheivement-value">{{
                  course?.institution || "N/A"
                }}</span>
              </div>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">Course Date :</span>
                <span class="doctor-acheivement-value">{{
                  course?.courseDate | date : "MM/dd/yyyy"
                }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="doctor-publications">
          <span class="cardTitle">Associations & Organizations</span>
          <p
            *ngIf="!(doctor?.moreInfos?.[0]?.associations?.length)"
            class="to-be-updated"
            id="associations"
          >
            To Be Updated Soon
          </p>
          <ul>
            <li *ngFor="let association of doctor?.associations">
              <b>{{ association?.associationName }}</b>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">Position :</span>
                <span class="doctor-acheivement-value">{{
                  association?.positionHeld || "N/A"
                }}</span>
              </div>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">From :</span>
                <span class="doctor-acheivement-value">{{
                  association?.fromDate | date : "MM/dd/yyyy"
                }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="doctor-publications">
          <span class="cardTitle">Volunteering & Causes</span>
          <p
            *ngIf="!(doctor?.moreInfos?.[0]?.volunteerings?.length)"
            class="to-be-updated"
          >
            To Be Updated Soon
          </p>
          <ul>
            <li *ngFor="let volunteer of doctor?.volunteerings">
              <b>{{ volunteer?.organizationName }}</b>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">Position :</span>
                <span class="doctor-acheivement-value">{{
                  volunteer?.positionHeld || "N/A"
                }}</span>
              </div>
              <div class="publications-detail-row">
                <span class="doctor-acheivement-label">From :</span>
                <span class="doctor-acheivement-value"
                  >{{
                    volunteer?.fromDate
                      ? (volunteer?.fromDate | date : "MM/dd/yyyy")
                      : "N/A"
                  }}
                  to
                  {{
                    volunteer?.toDate
                      ? (volunteer?.toDate | date : "MM/dd/yyyy")
                      : "N/A"
                  }}</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
      <img
        class="d-none d-lg-block custom-hide"
        src="assets/images/specialities_right-arrow.svg"
        alt="Right Arrow"
        (click)="slide('right', 'specialityContainer')"
        [class.disabled]="!canSlideRightSpecialities"
        style="cursor: pointer"
      />
    </div>
  </div>
  <div class="professional">
    <span>Professional Synopsis</span>
    <p *ngIf="!doctor?.description" class="to-be-updated">To Be Updated Soon</p>
    <p [innerHTML]="doctor?.description"></p>
  </div>
</div>

<app-website-footer></app-website-footer>
